import {moudleList} from 'api/moudle';
import Cookies from 'js-cookie';

const moudle = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        moudleList({commit},params) {
            return new Promise((resolve, reject) => {
                moudleList().then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        }
    }
};

export default moudle;



// WEBPACK FOOTER //
// ./src/store/modules/moudle.js